import { useCallback, useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../redux/configureStore";
import { ConfirmationRequest } from "../../app/types";
import { getConfirmation } from "../app/selectors";
import { addConfirmation, removeConfirmation } from "../app/uiSlice";

type ConfirmationHandler = (userAccepted: boolean) => void;

const useConfirmation = (
  confirmationRequest: ConfirmationRequest,
  confirmationHandler: ConfirmationHandler,
) => {
  const dispatch = useAppDispatch();
  const [uuid, setUuid] = useState<string>();

  const confirmation = useAppSelector(getConfirmation(uuid));

  const showConfirmation = useCallback(() => {
    const { payload } = dispatch(addConfirmation(confirmationRequest));
    setUuid(payload.uuid);
  }, [dispatch, confirmationRequest]);

  useEffect(() => {
    if (confirmation?.userAccepted !== undefined && uuid) {
      confirmationHandler(confirmation?.userAccepted);
      dispatch(removeConfirmation(uuid));
      setUuid(undefined);
    }
  }, [confirmation?.userAccepted, confirmationHandler, dispatch, uuid]);

  return showConfirmation;
};

export default useConfirmation;
